module.exports = __webpack_public_path__ + "static/img/55.86908751.jpeg";